import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import type { CreateJobPositionFormData } from '../schemas/jobPosition.schemas';
import {
  BasicInfoSection,
  EmploymentSection,
  SalarySection,
  EducationSection,
  SkillsSection,
  RequirementsSection,
  AdditionalInfoSection,
  DatesSection,
} from './form-sections';

export interface JobPositionFormFieldsProps {
  register: UseFormRegister<CreateJobPositionFormData>;
  errors: FieldErrors<CreateJobPositionFormData>;
  setValue: UseFormSetValue<CreateJobPositionFormData>;
  watch: UseFormWatch<CreateJobPositionFormData>;
}

export function JobPositionFormFields({
  register,
  errors,
  setValue,
  watch,
}: JobPositionFormFieldsProps): JSX.Element {
  const sectionProps = { register, errors, setValue, watch };

  return (
    <div className="space-y-6">
      <BasicInfoSection {...sectionProps} />
      <EmploymentSection {...sectionProps} />
      <SalarySection {...sectionProps} />
      <EducationSection {...sectionProps} />
      <SkillsSection {...sectionProps} />
      <RequirementsSection {...sectionProps} />
      <AdditionalInfoSection {...sectionProps} />
      <DatesSection {...sectionProps} />
    </div>
  );
}
